import { Box, Link, Typography, FormControlLabel, Checkbox } from '@mui/material';

import { container } from '../../pages/ProposalView';

const ProposalViewEditSection = ({ id, client, smallLogo, setSmallLogo }) => (
  <Box
    component="section"
    className="proposal-edit-section no-print"
    sx={{
      ...container,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: {
        xs: '50px 15px 0',
        md: '15px 0 0',
      },
      flexWrap: {
        xs: 'wrap',
        md: 'nowrap',
      },
      '@media print': {
        display: 'none !important',
      },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <FormControlLabel 
        control={
          <Checkbox 
            checked={smallLogo} 
            onChange={(e) => setSmallLogo(e.target.checked)} 
          />
        } 
        label="Small logo for print" 
      />
      {!client && <Link href={`/proposals/${id}`}>Edit Proposal</Link>}
    </Box>

    <Typography variant="body2" sx={{ fontSize: '1.05rem' }}>
      Questions? Contact your tech or call <Link href={`tel:619-655-3010`}>619-655-3010</Link>
    </Typography>
  </Box>
);

export default ProposalViewEditSection;
